/* eslint-disable @typescript-eslint/no-explicit-any -- DIRECT-239681 */

import type { QueryResultSelectorResult } from '../rtk-query-types';
import { createRequestScopedEvent } from './createRequestScopedEvent';

type RefetchCondition = (result: QueryResultSelectorResult<any>) => boolean;

/**
 * Событие для повторного вызова всех useQuery запросов, попадающих под определенное условие.
 *
 * @example
 * ```ts
 * import { refetchQueriesEvent } from '@direct-frontend/modules-store';
 *
 * refetchQueriesEvent.publish(queryResult => {
 *   // Перезапрошены будут только те запросы, которые попадают под условие
 *   return someCondition(queryResult);
 * });
 * ```
 * @remarks
 * На сервере подписки живут не дольше SSR-запроса, в котором были созданы, а событие
 * доставляется только подписчикам этого же запроса. Это не влияет на клиент: там подписки,
 * как и раньше, живут в единственном глобальном скоупе.
 *
 * @public
 */
export const refetchQueriesEvent = createRequestScopedEvent<RefetchCondition>('refetchQueriesEvent');
